import axios from 'axios'

export default {
    // 获取导出ExcelUrl
    getExcelUrl({commit}, params) {
        return axios.post('/api/background/canteen_order/list/excel/query', params)
    },
    // 生成EXCEL订单数据
    generateExcelDataList({commit}, params) {
        return axios.post('/api/background/canteen_order/list/excel/generate', params)
    },
    generateConsumptionExcelList({commit}, params){
        return axios.post('/api/facepay/consumption/user/list/excel/generate', params)
    },
    generateUserConsumptionList({commit}, params){
        return axios.post('/api/facepay/consumption/record/list/excel/generate', params)
    },
    //概况营业额导出excel接口
    generatePredayExcelList({commit}, params) {
        return axios.post('/api/background/business_detail/pre_day/excel/generate', params)
    },
    getTurnoverExcelInfo({commit}, params) {
        return axios.post('/api/background/turnover_day_trend_excel/get', params)
    },
    getFaceUserAcountExcel({commit}, params) {
        return axios.post('/api/facepay/shop/face/user/excel/get', params)
    },
    getFaceuserAccountDetailExcel({commit}, params) {
        return axios.post('/api/facepay/shop/face/user/order/excel/get', params)
    }
}


// WEBPACK FOOTER //
// ./src/vuex/actions/excel.js